import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@storable/canaveral-components';

const propTypes = {
  isUndoable: PropTypes.bool.isRequired,
  isRedoable: PropTypes.bool.isRequired,
  onUndo: PropTypes.func.isRequired,
  onRedo: PropTypes.func.isRequired,
};

const defaultProps = {};

const UndoRedoButtons = ({
  isUndoable, isRedoable, onUndo, onRedo,
}) => (
  <React.Fragment>
    <Button
      inverted
      size="sm"
      borderless
      icon="undo"
      label="Undo"
      shape="circle"
      context="subtle"
      onClick={onUndo}
      disabled={!isUndoable}
    />
    <Button
      inverted
      size="sm"
      borderless
      icon="redo"
      label="Redo"
      shape="circle"
      context="subtle"
      onClick={onRedo}
      disabled={!isRedoable}
    />
  </React.Fragment>
);

UndoRedoButtons.propTypes = propTypes;
UndoRedoButtons.defaultProps = defaultProps;

export default UndoRedoButtons;
